import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default {

	duration: 1,
	start: 'top 60%',

	init() {
		gsap.core.globals('ScrollTrigger', ScrollTrigger);

		Array.from(document.querySelectorAll('.fade-up')).forEach((element) => {
			gsap.from(element, {
				scrollTrigger: {
					trigger: element,
					start: this.start,
				},
				y: 100,
				opacity: 0,
				ease: 'sine.out',
				duration: this.duration,
			});
		});

		Array.from(document.querySelectorAll('.fade-left')).forEach((element) => {
			gsap.from(element, {
				scrollTrigger: {
					trigger: element,
					start: this.start,
				},
				x: 100,
				opacity: 0,
				ease: 'sine.out',
				duration: this.duration,
			});
		});

		Array.from(document.querySelectorAll('.fade-right')).forEach((element) => {
			gsap.from(element, {
				scrollTrigger: {
					trigger: element,
					start: this.start,
				},
				x: -100,
				opacity: 0,
				ease: 'sine.out',
				duration: this.duration,
			});
		});
	},

};
